const Base = require('../abstract/facade');

const components = {
  creators: {
    sticker: require('./creators/sticker'),
    shape: require('./creators/shape'),
    image: require('./creators/image'),
    group: require('./creators/group'),
    text: require('./creators/text'),
    icon: require('./creators/icon'),
    logo: require('./creators/logo'),
    video: require('./creators/video'),
    table: require('./creators/table'),
    qrcode: require('./creators/qrcode')
  },
  setters: {
    sticker: require('./setters/sticker'),
    shape: require('./setters/shape'),
    image: require('./setters/image'),
    background: require('./setters/background'),
    text: require('./setters/text'),
    group: require('./setters/group'),
    template: require('./setters/template'),
    icon: require('./setters/icon'),
    logo: require('./setters/logo'),
    video: require('./setters/video'),
    table: require('./setters/table'),
    qrcode: require('./setters/qrcode')
  },
  getters: {
    template: require('./getters/template'),
    text: require('./getters/text'),
    image: require('./getters/image'),
    sticker: require('./getters/sticker'),
    background: require('./getters/background'),
    group: require('./getters/group'),
    shape: require('./getters/shape'),
    icon: require('./getters/icon'),
    logo: require('./getters/logo'),
    video: require('./getters/video'),
    table: require('./getters/table'),
    qrcode: require('./getters/qrcode')
  }
};

function Facade () {
  this.handlers = {
    sticker: require('./handlers/sticker'),
    shape: require('./handlers/shape'),
    group: require('./handlers/group'),
    image: require('./handlers/image'),
    background: require('./handlers/background')
  };

  Object.entries(components).forEach(([componentName, component]) => {
    const componentGroup = {};
    Object.entries(component).forEach(([componentType, ComponentConstructor]) => {
      componentGroup[componentType] = new ComponentConstructor();
    });

    this[componentName] = componentGroup;
  });
}

Facade.prototype = new Base();
Facade.prototype.constructor = Facade;
Facade.prototype.initialize = function () {
  Base.prototype.initialize.call(this);

  _.invoke(this.getters, 'initialize');

  _.each(this.setters, function (setter, key) {
    setter.initialize();
    setter.on('all', _.partial(this.propagate, key + '.update'));
  }, this);

  _.each(this.creators, function (creator, key) {
    creator.initialize();
    creator.on('all', _.partial(this.propagate, key + '.create'));
  }, this);
};

Facade.prototype.get = function (id, attributeChain) {
  const restrictionsFacade = require('../restrictions/restrictions');

  if (typeof id === 'undefined') {
    let elements = $('#svgcontent').children('g.main').children();
    elements = _.filter(elements, function (el) { return el.getBBox; });

    const $background = $('#svgcontent').children('g.background');
    if ($background.children('rect').length || $background.children('image').length) {
      elements.unshift($background.children()[0]);
    }

    return _.map(elements, getSingleElement, this).reverse();
  }

  const passedElement = id && id.nodeType === 1;
  const elem = passedElement ? id : document.getElementById(id);

  return getSingleElement.call(this, elem);

  function getSingleElement (element) {
    const elementType = this.getters[id] ? id : this.getType(element);

    if (this.getters[elementType]) {
      const data = element
        ? this.getters[elementType].get(element, attributeChain)
        : this.getters[elementType].get(attributeChain);

      if (attributeChain) {
        return data;
      }

      let elementId = id;
      if (element) {
        elementId = $(element).parent().is('g.background') ? 'background' : element.getAttribute('id');
      }

      const name = restrictionsFacade.getElementName(elementId);
      const permissions = restrictionsFacade.getAllElementPermissions(elementId);

      return _.extend(data, {
        type: elementType,
        name,
        permissions
      });
    }
  }
};

Facade.prototype.create = function (elementType, data) {
  if (this.creators[elementType]) {
    return this.creators[elementType].create(data);
  }
};

Facade.prototype.set = function (id, data) {
  const isApplyToSelected = !_.isString(id) && !data;

  if (isApplyToSelected) {
    data = id;
    const elements = _.toArray(this.canvas.getSelectedElems());
    _.each(elements, function (element) {
      const type = this.getType(element);
      singleSet.call(this, this.getType(element), type !== 'background' && element);
    }, this);
  } else {
    const element = $('#' + id)[0];
    const elementType = this.setters[id] ? id : this.getType(element, id);
    singleSet.call(this, elementType, element);
  }

  function singleSet (elementType, element) {
    if (this.setters[elementType]) {
      element || this.setters[elementType].set(data);
      element && this.setters[elementType].set(element, data);
    } else {
      this.propagate('exception', id, null, data);
    }
  }
};

Facade.prototype.propagate = function (handler, eventKey, id, data) {
  const eventData = (typeof data === 'object' || !data)
    ? { ...(data || {}), id }
    : data;
  const mountEventName = key => `${key}${(eventKey ? '.' + eventKey : '')}`;

  if (id) {
    this.trigger(mountEventName(id), eventData);
  }

  this.trigger(mountEventName(handler), eventData);
};

module.exports = Facade;
